import { render, staticRenderFns } from "./AddonField.vue?vue&type=template&id=b2eb23b8&"
import script from "./AddonField.vue?vue&type=script&lang=js&"
export * from "./AddonField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports